
import { Injectable } from '@angular/core';
// FIX: Corrected import path for models.
import { InventoryLog } from '../models/index';
import { getSupabase, isSupabaseConfigured } from '../firebase';
import { SupabaseClient } from '@supabase/supabase-js';

@Injectable({ providedIn: 'root' })
export class InventoryService {
  private supabase: SupabaseClient | null = getSupabase();

  async processInventoryForOrder(orderId: string): Promise<{ success: boolean; message?: string }> {
    if (!isSupabaseConfigured() || !this.supabase) {
      return { success: true, message: "Mock mode: Inventory not updated." };
    }
    
    const { error } = await this.supabase.rpc('process_inventory_for_order', { p_order_id: orderId });

    if (error) {
      console.error("Inventory Error via RPC:", error);
      return { success: false, message: `Inventory update failed: ${error.message}` };
    }

    return { success: true };
  }
  
  async adjustStock(productId: string, userId: string, changeAmount: number, reason: 'RESTOCK' | 'ADJUST_DAMAGE' | 'ADJUST_CORRECTION' | 'ADJUST_THEFT'): Promise<void> {
    if (!isSupabaseConfigured() || !this.supabase) {
        return;
    }
    const { error } = await this.supabase.rpc('adjust_stock', {
      p_product_id: productId,
      p_user_id: userId,
      p_change_amount: changeAmount,
      p_reason: reason
    });
    if (error) throw error;
  }

  async getInventoryHistory(productId: string): Promise<InventoryLog[]> {
    if (!isSupabaseConfigured() || !this.supabase) {
        return [];
    }
    
    const { data, error } = await this.supabase.rpc('get_inventory_history', { p_product_id: productId });
    
    if (error) {
      console.error("Error fetching inventory history:", error);
      throw error;
    }
    
    return data as InventoryLog[];
  }
}
